import type { SVGAttributes } from "react";
import type { ColorToken } from "../../../../theme/styled";
import { getColor } from "../../../../theme/styled/theme/themeContext/themeContext";

type SVGProps = Pick<
  SVGAttributes<SVGSVGElement>,
  "onMouseEnter" | "onMouseLeave" | "className" | "style" | "aria-hidden"
>;

export interface IconProps extends SVGProps {
  size: 12 | 16 | 24 | 48;
  colorToken?: ColorToken | "currentColor" | "transparent";
  /**
   * Avoid using _color. Use colorToken instead.
   */
  _color?: string;
}

interface InternalIconProps extends SVGProps {
  size?: 12 | 16 | 24 | 48;
  color: string;
}

export function iconProps(props: IconProps): InternalIconProps {
  const { colorToken, _color, ...rest } = props;

  const color = (() => {
    if (isColorToken(colorToken)) {
      return getColor(colorToken);
    } else if (_color) {
      return _color;
    } else {
      return "currentColor";
    }
  })();

  return { color, "aria-hidden": true, ...rest };
}

const isColorToken = (token: IconProps["colorToken"]): token is ColorToken => {
  return Boolean(token?.startsWith("$"));
};
